module.exports = __webpack_public_path__ + "static/media/creme (2).8c35b24c.jpg";